import React from "react";
import { ArrowDownIcon } from "lucide-react";
import { SectionCta } from "../SectionCta";
import { separateTopics } from "../../data/clinicalDecisions";
export function GapSection() {
  return <section className="w-full bg-navy-deep px-5 py-16 sm:py-24" data-id="element-223" data-mp="3cvbqetc1vxre">
      <div className="mx-auto max-w-4xl text-center" data-id="element-224" data-mp="3cwmtss1l33hz">
        <h2 className="font-serif text-[28px] font-black leading-tight text-white sm:text-4xl" data-id="element-225" data-mp="383a3mdh9aon4">
          Here’s What Most Orthodontic References Don’t Make Easy
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-lg text-white/80" data-id="element-226" data-mp="3huejrgio4fjj">
          Orthodontic education often presents important topics separately:
        </p>

        <ul className="mt-8 flex flex-wrap justify-center gap-2.5" data-id="element-227" data-mp="3vrjuvux8o4ln">
          {separateTopics.map(t => <li key={t} className="rounded-full border border-white/20 px-4 py-2 text-sm font-semibold text-white/90 sm:text-base" data-id="element-228" data-mp="3rq861rm6vnei">
              {t}
            </li>)}
        </ul>

        <p className="mx-auto mt-8 max-w-2xl text-lg text-white/80" data-id="element-229" data-mp="2q97eqlv1ybi8">
          But when a growing patient arrives for evaluation, you need to consider these elements{" "}
          <strong className="text-white" data-id="element-230" data-mp="306lx4r0jdad6">together</strong>. You need to understand the relationship between
          what you observe, what it means, and what decisions may be appropriate.
        </p>

        <ArrowDownIcon className="mx-auto mt-8 h-8 w-8 text-gold" aria-hidden="true" data-id="element-231" data-mp="39wf5zk9anbdq" />

        <div className="mx-auto mt-6 max-w-2xl rounded-3xl bg-wine px-6 py-8" data-id="element-232" data-mp="39yrk1mbxl1li">
          <p className="text-sm font-bold uppercase tracking-widest text-white/80" data-id="element-233" data-mp="3dw78pgc0anb6">
            The central idea behind the Blueprint™
          </p>
          <p className="mt-3 font-serif text-2xl font-bold leading-snug text-white sm:text-3xl" data-id="element-234" data-mp="3nwpy0qmcaw0h">
            A visual educational reference that brings these considerations into one organized learning
            pathway.
          </p>
        </div>

        <SectionCta label="Discover the complete clinical system" tone="dark" data-id="element-235" data-mp="1tif96i5qw1up" />
      </div>
    </section>;
}